import React from "react";
import { MdPhone } from "react-icons/md";
import styled from "styled-components/macro";
import FooterSection from "./FooterSection";
import { ImYoutube } from "react-icons/im";
import { FaFacebookSquare } from "react-icons/fa";
import { colors } from "theme/Theme";
import { HoverableText } from "theme/GlobalElements";
import { Link } from "react-router-dom";

interface SocialSectionProps {}

const SocialSection: React.FC<SocialSectionProps> = ({}) => {
  return (
    <FooterSection title="За повече контакти">
      <Text className="text-sm">Гореща линия</Text>
      <PhoneContainer href="tel:+359894468805">
        <MdPhone color="white" size="1.5em" />
        <Text className="text-sm">+359 894 468 805</Text>
      </PhoneContainer>
      <SocialLinks>
        <FbIcon
          color={colors.dark_gray}
          size="2em"
          style={{ paddingLeft: "20px" }}
        />
        <YtIcon
          color={colors.dark_gray}
          size="2em"
          style={{ paddingLeft: "20px" }}
        />
      </SocialLinks>
      <TextHoverLink to={"/policy"} className="text-xs">
        * Политика за поверителност
      </TextHoverLink>
      <TextHoverLink to={"/terms-and-conditions"} className="text-xs">
        * Общи условия за ползване
      </TextHoverLink>
    </FooterSection>
  );
};

export const Text = styled.span`
  color: white;
  & + & {
    margin-top: 10px;
  }
`;

export const PhoneContainer = styled.a`
  margin: 20px 0;
  display: inline-flex;
  align-self: center;
  justify-content: space-evenly;
  height: 50px;
  width: 80%;
  border-radius: 15px;
  border: 2px ${colors.dark_gray} solid;
  align-self: start;
  text-decoration: none;
  transition: 0.2s all;
  &:hover {
    border-color: white;
    background-color: #4cda64;
  }
  & > svg {
    align-self: center;
  }

  & > span {
    align-self: center;
    font-weight: 700;
  }
`;

const FbIcon = styled(FaFacebookSquare)`
  transition: 0.2s all;

  &:hover {
    fill: #4267b2;
  }
`;
const YtIcon = styled(ImYoutube)`
  transition: 0.2s all;

  &:hover {
    fill: #ff0000;
  }
`;

const SocialLinks = styled.div`
  display: inline-flex;
  align-items: center;
  align-self: start;
  justify-content: center;
  flex: 1;
  margin-bottom: 20px;
`;

const TextHover = styled(HoverableText)`
  color: white;
  cursor: pointer;
  & + & {
    margin-top: 10px;
  }
`;

const TextHoverLink = styled(Link)`
  color: white;
  cursor: pointer;
  & + & {
    margin-top: 10px;
  }
`;
export default SocialSection;
